import { fromEvent, map, filter, distinctUntilChanged } from "rxjs";
import { store$ } from "@redux/store";

const hasValue = (value) => !!value;
class CheckboxGroup {
    constructor(element){
        this.element = element;
        this.checkbox$ = fromEvent(element, 'change').pipe(
            map((event) => event.target),
            map((target) =>  target.closest('[data-group]')),
            map((parent) => Array.from(parent?.querySelectorAll(':checked'))?.map(option => option.value)))
    }
    
    setSelector(selector){
        // if we provide a selector in the constructor, we will use it to sync the checkboxes with the store's value.
        if(selector){
            const onStoreChange$ = store$.pipe(map(selector), filter(hasValue), distinctUntilChanged());
            onStoreChange$.subscribe(checkboxes => {
                // get all the checkboxes in the group
                this.element?.querySelectorAll('[type="checkbox"]').forEach((checkbox) => {
                    const value = checkbox.value;
                    checkbox.checked = Boolean(checkboxes[value])
                });
            });
        }
    }

    getObservable(){
        return this.checkbox$;
    }
}

export default CheckboxGroup;